<template>
  <div class="game">
    <div class="game__main">
      <canvas ref="view" class="game__view"></canvas>
      <div class="game__bar">
        <img src="@/assets/game/bar.png" />

        <div class="game__time">{{ time }}</div>
        <div class="game__wind">
          <img class="game__wind__icon" src="@/assets/game/arrow-left.png" :class="{ 'game__wind__icon--visible': windValue < -0.21 }" />
          <img class="game__wind__icon" src="@/assets/game/arrow-left.png" :class="{ 'game__wind__icon--visible': windValue < -0.11 }" />
          <img class="game__wind__icon" src="@/assets/game/arrow-left.png" :class="{ 'game__wind__icon--visible': windValue < 0}" />
          <img class="game__wind__icon" src="@/assets/game/arrow-right.png" :class="{ 'game__wind__icon--visible': windValue > 0 }" />
          <img class="game__wind__icon" src="@/assets/game/arrow-right.png" :class="{ 'game__wind__icon--visible': windValue > 0.11 }" />
          <img class="game__wind__icon" src="@/assets/game/arrow-right.png" :class="{ 'game__wind__icon--visible': windValue > 0.21 }" />
        </div>
      </div>

      <div class="game__buttons">
        <div class="game__button game__button--left" @click="moveX(-10)"><img src="@/assets/game/button-left.png" /></div>
        <div class="game__button game__button--right" @click="moveX(10)"><img src="@/assets/game/button-right.png" /></div>
        <div class="game__button game__button--up" @click="moveY(-10)"><img src="@/assets/game/button-up.png" /></div>
        <div class="game__button game__button--down" @click="moveY(10)"><img src="@/assets/game/button-down.png" /></div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable global-require */
import { TweenLite } from 'gsap';
import * as Matter from 'matter-js';
import * as PIXI from 'pixi.js';

const GAME_WIDTH = 960;
const GAME_HEIGHT = 800;

export default {
  name: 'VGame',

  data: () => ({
    app: undefined,
    constraint: undefined,
    windInterval: undefined,
    timeInterval: undefined,
    windValue: 0,
    score: 0,
    time: 0,
    startTime: undefined,
    isPlaying: true,
  }),

  beforeDestroy() {
    clearInterval(this.timeInterval);
    clearInterval(this.windInterval);
    this.app.destroy();
  },

  mounted() {
    const { view } = this.$refs;

    const runner = Matter.Runner.create();
    const engine = Matter.Engine.create();

    const square = Matter.Bodies.rectangle(100, 400, 62, 62, {
      density: 1,
      frictionAir: 0.005,
    });
    
    const constraint = Matter.Constraint.create({
      pointA: { x: 310, y: 345 },
      bodyB: square,
      stiffness: 0.25,
    });

    this.constraint = constraint;

    const obstacle = Matter.Bodies.rectangle(500, 700, 162, 61, {
      isStatic: true,
    });

    const collider = Matter.Bodies.rectangle(480, 670, 10, 10, {
      isSensor: true,
      isStatic: true,
    });

    Matter.Composite.add(engine.world, square);
    Matter.Composite.add(engine.world, constraint);
    Matter.Composite.add(engine.world, obstacle);
    Matter.Composite.add(engine.world, collider);
    Matter.Runner.run(runner, engine);

    const app = new PIXI.Application({
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
      view,
      preserveDrawingBuffer: true,
      transparent: true,
    });

    const background = this.initBackground(app);
    const crane = this.initCrane(app);
    const line = this.initLine(app);
    const pulley = this.initPulley(app);
    const crate = this.initCrate(app);
    const truck = this.initTruck(app);

    console.log(pulley)

    Matter.Events.on(engine, 'collisionStart', (event) => {
      if (!this.isPlaying) {
        return;
      }

      const { pairs } = event;
      
      const myk = !!pairs.filter(pair => pair.bodyA === collider || pair.bodyB === collider).length;

      if (!myk) {
        return;
      }

      this.isPlaying = false;
      Matter.Runner.stop(runner);
      this.end();
    });

    app.ticker.add(() => {
      pulley.position.x = constraint.pointA.x;
      pulley.position.y = constraint.pointA.y;

      crate.position.x = square.position.x;
      crate.position.y = square.position.y;
      crate.rotation = square.angle;

      truck.position.x = obstacle.position.x;
      truck.position.y = obstacle.position.y;

      line.clear();
      line.lineStyle(1, 0x000000);
      // line.position.set();
      line.moveTo(constraint.pointA.x - 10, constraint.pointA.y);
      line.lineTo(square.position.x - 5, square.position.y);
      line.moveTo(constraint.pointA.x + 10, constraint.pointA.y);
      line.lineTo(square.position.x + 5, square.position.y);
    });

    this.app = app;

    this.startTime = Date.now();

    this.timeInterval = setInterval(() => {
      const currentTime = Date.now();
      const timeDiff = Math.floor((currentTime - this.startTime) / 1000);

      this.time = timeDiff;
    }, 500);

    this.windInterval = setInterval(() => {
      const windDiff = Math.round(Math.random() * 2 - 1) * 0.1;
      this.windValue = Math.max(-0.3, Math.min(this.windValue + windDiff, 0.3));

      engine.world.gravity.x = this.windValue;
    }, 500);
  },

  methods: {
    initBackground(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/background.png'),
      );

      sprite.anchor.set(0.5);
      sprite.position.x = GAME_WIDTH / 2;
      sprite.position.y = GAME_HEIGHT / 2;

      app.stage.addChild(sprite);

      return sprite;
    },

    initCrane(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/crane.png'),
      );

      sprite.anchor.set(0, 1);
      sprite.position.x = 90;
      sprite.position.y = GAME_HEIGHT - 80;

      app.stage.addChild(sprite);

      return sprite;
    },

    initLine(app) {
      const graphics = new PIXI.Graphics();

      app.stage.addChild(graphics);

      return graphics;
    },

    initPulley(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/pulley.png'),
      );

      sprite.anchor.set(0.5, 0.5);

      app.stage.addChild(sprite);

      return sprite;
    },

    initCrate(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/crate.png'),
      );

      sprite.anchor.set(0.5, 0.5);

      app.stage.addChild(sprite);

      return sprite;
    },

    initTruck(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/truck.png'),
      );

      sprite.anchor.set(0.5, 0.5);

      app.stage.addChild(sprite);

      return sprite;
    },

    initTarget(app) {
      const sprite = PIXI.Sprite.from(
        require('@/assets/game/crate.png'),
      );

      sprite.anchor.set(0.5, 0.5);

      app.stage.addChild(sprite);

      return sprite;
    },

    moveX(diff) {
      if (!this.isPlaying) { return; }
      TweenLite.to(this.constraint.pointA, 0.25, {
        x: Math.max(270, Math.min(this.constraint.pointA.x + diff, 450)),
      });
    },

    moveY(diff) {
      if (!this.isPlaying) { return; }
      TweenLite.to(this.constraint, 0.25, {
        length: Math.max(150, Math.min(this.constraint.length + diff, 325)),
      });
    },

    async end() {
      clearInterval(this.timeInterval);
      clearInterval(this.windInterval);
      this.$emit('end', {
        score: this.time,
      });
    },
  },
};
</script>

<style lang="scss">
.game {
  background-color: #535156;

  &__view {
    display: block;
    width: 100%;
    height: auto;
  }

  &__main {
    position: relative;
  }

  &__bar {
    position: absolute;
    top: 5%;
    left: 50%;
    width: 90%;

    transform: translateX(-50%);

    img {
      display: block;
      width: 100%;
    }
  }

  &__time {
    position: absolute;
    top: 50%;
    left: 21%;

    transform: translate(-50%, -50%);

    font-family: 'Anton', Arial, Helvetica, sans-serif;
    text-align: center;
    font-size: font(18px, 40px);
    color: #ffffff;
  }

  &__wind {
    position: absolute;
    top: 50%;
    left: 79%;
    height: 100%;

    transform: translate(-50%, -50%);

    font-family: 'Anton', Arial, Helvetica, sans-serif;
    text-align: center;
    font-size: 40px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    &__icon {
      height: 40%;
      width: auto;

      opacity: 0;

      &--visible {
        opacity: 1;
      }
    }
  }

  &__buttons {
    position: absolute;
    bottom: 1%;
    height: 9%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__button {
    margin: 1%;
    height: 100%;
    cursor: pointer;
    opacity: 0.9;
    transition: opacity 0.1s;

    &:hover {
      opacity: 1;
    }

    img {
      display: block;
      height: 100%;
      width: auto;
    }
  }
}
</style>
